export default __webpack_public_path__ + "static/media/edgenta-page.acc12692.png";